webpackJsonp([49],{

/***/ 1978:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY2NjcgMTIuNjY2N0gzLjMzMzMzVjMuMzMzMzNIOFYySDMuMzMzMzNDMi41OTY2NyAyIDIgMi41OTY2NyAyIDMuMzMzMzNWMTIuNjY2N0MyIDEzLjQwMzMgMi41OTY2NyAxNCAzLjMzMzMzIDE0SDEyLjY2NjdDMTMuNDAzMyAxNCAxNCAxMy40MDMzIDE0IDEyLjY2NjdWOEgxMi42NjY3VjEyLjY2NjdaTTkuMzMzMzMgMlYzLjMzMzMzSDExLjcyMzNMNS4xNyA5Ljg4NjY3TDYuMTEzMzMgMTAuODNMMTIuNjY2NyA0LjI3NjY3VjYuNjY2NjdIMTRWMkg5LjMzMzMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 2062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_profile__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_product__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_me__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_comment__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_digital_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_accordion__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_item__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_user__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_comments__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_user_tag__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_user_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_user_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sharemodal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sharemodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_sharemodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_productcard__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_productcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_productcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_albumfinishmodal__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_albumfinishmodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_albumfinishmodal__);


/* global $:true */


// import CategoryService from '@/services/category'
// import UserService from '@/services/user'


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    digitalUploader: __WEBPACK_IMPORTED_MODULE_8__components_digital_uploader___default.a,
    contentTopHeader: __WEBPACK_IMPORTED_MODULE_9__components_contentTopHeader___default.a,
    accordion: __WEBPACK_IMPORTED_MODULE_10__components_accordion___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_13__components_comments___default.a,
    UserTag: __WEBPACK_IMPORTED_MODULE_14__components_user_tag___default.a,
    ShareModal: __WEBPACK_IMPORTED_MODULE_15__components_sharemodal___default.a,
    UserFollowBtn: __WEBPACK_IMPORTED_MODULE_16__components_userFollowBtn___default.a,
    productCard: __WEBPACK_IMPORTED_MODULE_18__components_productcard___default.a,
    albumFinishModal: __WEBPACK_IMPORTED_MODULE_19__components_albumfinishmodal___default.a
  },

  data: function data() {
    return {
      products: {},
      share_dialog: false,
      info_dialog: false,
      info_active_tab: 1,
      option: '',
      selectedCover: null,
      product_categories: [],
      countries: [],
      states: [],
      digital_content_category_ids: [],
      digital_content: {
        file: null
      },
      prod_id: '',
      product_image1: null,
      product_image1_url: null,
      product_image2: null,
      product_image2_url: null,
      product_image3: null,
      product_image3_url: null,
      product: {},
      product_variants: [{
        name: '',
        quantity: '',
        price: ''
      }],
      users: [],
      collaborators_confirm_dialog: false,
      isPageReady: false,
      buttonHover: false,
      comments: [],
      commentTableType: "ShopProduct",
      comment_pagination: {
        count: 0,
        current_page: 0,
        per_page: 5,
        total_count: 0,
        total_pages: 0
      },
      releaseProduct: null,
      showReleaseProductModal: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapGetters */])({
    isAuthenticated: "auth/isAuthenticated"
  }), {
    onMobile: function onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    commentsCount: function commentsCount() {
      if (this.comment_pagination.total_count > 0) {
        return this.comment_pagination.total_count;
      } else {
        return 'No';
      }
    },
    hasMoreComments: function hasMoreComments() {
      return this.comment_pagination.current_page < this.comment_pagination.total_pages;
    },
    followButtonText: function followButtonText() {
      if (this.user.is_following) {
        return this.buttonHover ? 'Unfollow' : 'Following';
      }
      return 'Follow';
    },
    user: function user() {
      if (this.product.slug) {
        return this.product.user;
      } else {
        return this.product.merchant;
      }
    },
    currentUser: function currentUser() {
      return this.$store.state.auth.user;
    },
    accordions: function accordions() {
      var policies = [{
        title: 'Size & Fit',
        content: this.product.merchant.size_chart
      }, {
        title: 'Shipping Policy',
        content: this.product.merchant.shipping_policy
      }, {
        title: 'Return Policy',
        content: this.product.merchant.return_policy
      }, {
        title: 'Privacy Policy',
        content: this.product.merchant.privacy_policy
      }];

      return policies;
    },
    options: function options() {
      var options = [];
      for (var index in this.product.variants) {
        var variant = this.product.variants[index];
        if (this.isDigitalProduct || variant.quantity > 0) {
          var option = {
            id: variant.id,
            name: variant.name
          };
          options.push(option);
        }
      }

      console.log(options);
      return options;
    },
    isDigitalProduct: function isDigitalProduct() {
      return this.digital_content_category_ids.indexOf(this.product.category) > -1;
    },
    isAvailableToUpdateProduct: function isAvailableToUpdateProduct() {
      var isAvailable = this.product.name && this.product.category && this.product_image1_url;
      if (this.product.variants.length) {
        for (var index in this.product.variants) {
          var variant = this.product.variants[index];
          isAvailable = isAvailable && variant.name.length && (this.isDigitalProduct || parseFloat(variant.quantity) >= 0) && parseFloat(variant.price) > 0;
        }
        if (this.isDigitalProduct) {
          isAvailable = isAvailable && this.digital_content.file;
        } else {
          if (this.product.shipments.length) {
            for (var _index in this.product.shipments) {
              var shipment = this.product.shipments[_index];
              isAvailable = isAvailable && shipment.country.length && parseFloat(shipment.shipment_alone_price) > 0 && parseFloat(shipment.shipment_with_price) >= 0;
            }
          } else {
            isAvailable = false;
          }
        }
      } else {
        isAvailable = false;
      }
      return isAvailable;
    },
    isEditable: function isEditable() {
      return ['privated', 'published', 'collaborated'].indexOf(this.product.status) === -1;
    },
    creator_share: function creator_share() {
      return 100 - __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sumBy(this.product.collaborators, 'user_share');
    },
    profit_share_types: function profit_share_types() {
      return __WEBPACK_IMPORTED_MODULE_7__helper__["N" /* CollaboratorProfitShareTypes */];
    },
    productCategoryName: function productCategoryName() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.product_categories, function (pc) {
        return pc.id === _this.product.category;
      }), 'name', '');
    },
    covers: function covers() {
      var imgs = this.product.covers || [];
      var covers = [];
      imgs.forEach(function (img) {
        if (img.cover.url) {
          covers.push(img.cover.url);
        }
      });

      // imgs = [
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/shop_product_cover/cover/125/523b9cda-b1a7-4cf0-9fe2-619c63a15f34.jpg',
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/album/cover/42/b5fe3a4c-4221-402d-ab22-4b1a52e474ac.jpg',
      //   'https://d19mruzykfu6hg.cloudfront.net/uploads/album/cover/33/73c40199-a5ac-463e-9154-09581f92c987.jpg',
      // ]

      // return imgs
      return covers;
    },
    initImgSelection: function initImgSelection() {
      console.log(this.covers);
      return this.covers[0];
    }
  }),
  created: function created() {
    var _this2 = this;

    // if (
    //         this.$store.state.auth.user &&
    //         ['artist', 'brand', 'label'].indexOf(
    //             this.$store.state.auth.user.user_type
    //         ) > -1
    //     ) {
    var prodParams = localStorage.getItem("release_product");
    if (prodParams) {
      __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].getProduct(parseInt(prodParams)).then(function (resp) {
        _this2.releaseProduct = resp.body;
        if (_this2.releaseProduct) {
          _this2.showReleaseProductModal = true;
          localStorage.removeItem("release_product");
        }
      });
    }
    this.prod_id = this.$route.params.id;
    // const params = {
    //   filter: 'artist',
    //   page: 1,
    //   per_page: 30,
    // }
    var params = {
      stripe_connected: true,
      page: 1,
      per_page: 30
    };
    this.isPageReady = false;
    this.$store.dispatch('error/showLoadingActivity', true);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([
    // CategoryService.getCategories(),
    // UserService.searchUsers(params),
    // ProfileService.getItems(
    //   this.$store.state.auth.user.id,
    //   'followings',
    //   params
    // ),
    __WEBPACK_IMPORTED_MODULE_5__services_me__["a" /* default */].mutualUsers(params), __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].getProduct(this.prod_id)]).then(function (values) {
      _this2.product_categories = _this2.$store.state.app.product_categories;
      _this2.digital_content_category_ids = _this2.$store.getters['app/digitalCategoryIds'];

      _this2.users = values[0].body.users;

      _this2.product = values[1].body;
      console.log(_this2.product);
      _this2.product.category = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this2.product, 'category.id', '');
      _this2.product.creator_recoup_cost /= 100;
      _this2.product_image1_url = _this2.product.covers[0].cover.url;
      _this2.product_image2_url = _this2.product.covers[1].cover.url;
      _this2.product_image3_url = _this2.product.covers[2].cover.url;
      _this2.product.price /= 100;
      for (var index in _this2.product.variants) {
        _this2.product.variants[index].price /= 100;
      }
      for (var _index2 in _this2.product.shipments) {
        _this2.product.shipments[_index2].shipment_alone_price /= 100;
        _this2.product.shipments[_index2].shipment_with_price /= 100;
      }

      if (_this2.product.digital_content_url) {
        _this2.digital_content.file = {
          name: _this2.product.digital_content_name
        };
      }

      _this2.isPageReady = true;
      _this2.$store.dispatch('error/showLoadingActivity', false);

      __WEBPACK_IMPORTED_MODULE_5__services_me__["a" /* default */].mutualUsers(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, { per_page: -1 })).then(function (response) {
        return _this2.users = response.body.users;
      });
      _this2.loadMoreComments();
      var params = { statuses: "published, collaborated", stock_statuses: "active", user_statuses: "accepted" };
      __WEBPACK_IMPORTED_MODULE_3__services_profile__["a" /* default */].getItems(_this2.product.merchant.id, 'merch', params).then(function (resp) {
        _this2.products = resp.body.products.filter(function (p) {
          return p.id !== _this2.prod_id;
        }).slice(0, 4);
      }).catch(function (exception) {
        console.log(exception);
      });
    }).catch(function (reason) {
      console.log(reason);
      _this2.$store.dispatch('error/showLoadingActivity', false);
      _this2.$store.dispatch('error/showErrorToast', reason);
    });
    // } else {
    //   this.$router.push({ path: '/' })
    // }
  },

  watch: {
    initImgSelection: {
      handler: function handler(newVal, oldVal) {
        this.selectedCover = newVal;
      },

      immediate: true
    },
    $route: function $route(to, from) {
      console.log("asdfasdfsdf===comments");
      this.loadMoreComments();
    }
  },
  methods: {
    reRenderComments: function reRenderComments() {
      this.comment_pagination.current_page = 0;
      this.comment_pagination.per_page = 5;
      this.comments = [];
      this.loadMoreComments();
    },
    dismissFinishDialog: function dismissFinishDialog() {
      this.showReleaseProductModal = false;
    },
    showPromoteModal: function showPromoteModal() {},
    closeShareDialog: function closeShareDialog() {
      this.share_dialog = false;
    },
    repostProduct: function repostProduct() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].repostProduct(this.product.id).then(function (response) {
        _this3.$store.dispatch("error/showSuccessToast", ["You just reposted " + _this3.product.name]);
      }).catch(function (e) {
        _this3.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    addToCollections: function addToCollections() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_product__["a" /* default */].addIntoCollection(this.product.id).then(function (resp) {
        _this4.$store.dispatch("error/showSuccessToast", ["You just added " + _this4.product.name + " in your wishlist."]);
      }).catch(function (e) {
        _this4.$store.dispatch("error/showErrorToast", e.body.errors || [e.body]);
      });
    },
    afterFollow: function afterFollow(isfollowing) {
      if (isfollowing === "unfollow") {
        this.product.merchant.is_following = false;
      } else if (isfollowing === "follow") {
        this.product.merchant.is_following = true;
      }
    },
    addToCart: function addToCart() {
      var _this5 = this;

      if (this.option === '' || this.option === null) {
        this.$store.dispatch('error/showErrorToast', ['Please select valid variant.']);
      } else {
        var pageTrack = '';
        if (this.$store.state.streamPlayer.frame_mode === 'full') {
          var streamId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.$store.state.streamPlayer.stream, 'id', '');
          if (streamId !== '') {
            pageTrack = 'Stream: ' + streamId;
          }
        }
        var params = {
          product_variant_id: this.option,
          quantity: 1,
          page_track: pageTrack
        };

        __WEBPACK_IMPORTED_MODULE_11__services_item__["a" /* default */].addToCart(params).then(function (response) {
          if (response.body.errors) {
            _this5.$store.dispatch('error/showErrorToast', response.body.errors);
          } else {
            _this5.$store.dispatch('error/showSuccessToast', ['Added successfully to Cart.']);
          }
        }).catch(function (e) {
          _this5.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
        });
      }
    },
    changeFeaturedImage: function changeFeaturedImage(img) {
      if (this.selectedCover == null) {
        this.selectedCover = this.initImgSelection;
      } else {
        this.selectedCover = img;
      }
    },
    loadMoreComments: function loadMoreComments() {
      var _this6 = this;

      var params = {
        commentable_type: 'ShopProduct',
        commentable_id: this.product.id,
        page: this.comment_pagination.current_page + 1,
        per_page: this.comment_pagination.per_page
      };
      __WEBPACK_IMPORTED_MODULE_6__services_comment__["a" /* default */].getComments(params).then(function (response) {
        _this6.comments = _this6.comments.concat(response.body.comments);
        _this6.comment_pagination = response.body.pagination;
      }).catch(function (e) {
        _this6.$store.dispatch('error/showErrorToast', e.body.errors || [e.body]);
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 2076:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1890)(true);
// imports


// module
exports.push([module.i, ".page-content[data-v-21f7bcfa]{margin-top:45px}.filter-invert[data-v-21f7bcfa]{filter:invert(1)}.w-100[data-v-21f7bcfa]{width:100}.gap-20[data-v-21f7bcfa]{gap:20px}.general-heading[data-v-21f7bcfa]{font-family:Inter,sans-serif;font-weight:700;font-size:20px}.divider-x[data-v-21f7bcfa]{width:100%;height:1px;background-color:rgba(0,0,0,.2)}.info-dialog[data-v-21f7bcfa]{width:70%!important;max-width:1100px!important}.info-dialog .card[data-v-21f7bcfa]{padding:30px}.info-dialog .modal-head[data-v-21f7bcfa]{font-size:16px;font-family:Inter,sans-serif;font-weight:600;cursor:pointer;color:#000;opacity:.5}.info-dialog .modal-head.active[data-v-21f7bcfa]{opacity:1}.info-dialog .modal-body-text[data-v-21f7bcfa]{font-size:16px;font-weight:400}.single-product-page .product-container[data-v-21f7bcfa]{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;font-family:Inter,sans-serif}.single-product-page .product-container .product-section[data-v-21f7bcfa]{font-family:Inter,sans-serif}.single-product-page .product-container .input-group--select__autocomplete[data-v-21f7bcfa]{background-color:transparent!important}.single-product-page .product-container .product-side-thumbnails .product-thumbnail[data-v-21f7bcfa]{width:100%;background-position:50%}.single-product-page .product-container .product-side-thumbnails .product-covers[data-v-21f7bcfa]{position:relative;height:130px;width:130px;background-position:50%;background-size:cover;margin-bottom:25px;cursor:pointer;box-shadow:none;border-radius:6px;overflow:hidden}.single-product-page .product-container .product-side-thumbnails .product-covers[data-v-21f7bcfa]:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background-color:none}.single-product-page .product-container .product-side-thumbnails .selected .product-covers[data-v-21f7bcfa]:after{background-color:transparent;box-shadow:0 0 4px 0 hsla(240,5%,62%,.562)}.single-product-page .product-container .product-cover-selected[data-v-21f7bcfa]{width:75%}.single-product-page .product-container .product-cover-selected .__selected[data-v-21f7bcfa]{height:600px;width:100%;background-position:50%;background-size:contain}.single-product-page .flex-center[data-v-21f7bcfa]{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.single-product-page .flex-center .w-80[data-v-21f7bcfa]{width:80%}.single-product-page .info-link-container .gap-15[data-v-21f7bcfa]{gap:10px}.single-product-page .info-link-container .info-modal-links[data-v-21f7bcfa]{margin-bottom:15px;cursor:pointer}.single-product-page .info-link-container .info-modal-links[data-v-21f7bcfa]:hover{opacity:.8}.single-product-page .info-link-container .info-link-text[data-v-21f7bcfa]{font-weight:500;font-size:16px;color:#000;font-family:Inter,sans-serif}.single-product-page .product-category[data-v-21f7bcfa]{font-weight:700;font-size:14px;color:rgba(0,0,0,.5);font-family:Inter,sans-serif}.single-product-page .product-name[data-v-21f7bcfa]{font-size:34px;font-weight:700;color:#000;line-height:1;font-family:Inter,sans-serif}.single-product-page .product-merchant[data-v-21f7bcfa]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.single-product-page .product-merchant .tag__image[data-v-21f7bcfa]{height:50px;width:50px;background-size:cover;background-position:50%;border-radius:100%;margin-right:10px}.single-product-page .product-merchant .tag__name[data-v-21f7bcfa]{font-size:12px;font-weight:700;text-transform:uppercase}.single-product-page .product-price[data-v-21f7bcfa]{font-size:16px;font-weight:700;letter-spacing:-1%;margin:10px 0 30px}.single-product-page .product-options[data-v-21f7bcfa]{margin-top:30px}.single-product-page .product-options__title[data-v-21f7bcfa]{font-weight:700;font-size:16px}.single-product-page .product-addTobag[data-v-21f7bcfa]{margin-top:15px;height:50px;font-size:16px;font-weight:700}.single-product-page .product-description[data-v-21f7bcfa]{line-height:2;color:#000;margin-top:30px;height:100px;overflow-y:auto}.single-product-page .product-description[data-v-21f7bcfa]:first-letter{text-transform:capitalize}.single-product-page .product-actions[data-v-21f7bcfa]{margin-top:20px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.single-product-page .product-actions .__actions[data-v-21f7bcfa]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.single-product-page .product-actions .follow-btx[data-v-21f7bcfa]{text-transform:none;box-shadow:none;height:31px;font-size:14px;letter-spacing:0;min-width:100px;font-family:DM Sans,sans-serif;font-weight:700;border-radius:4px}.single-product-page .product-actions .follow-btx.follow[data-v-21f7bcfa]{border:1px solid #076aff;background-color:#076aff!important;color:#fff!important}.single-product-page .product-actions .follow-btx.following[data-v-21f7bcfa]{border:1px solid #000;border-radius:100px;background-color:#0000!important;color:#000!important}.single-product-page .product-actions .follow-btx.following[data-v-21f7bcfa]:hover{border:.75px solid #dc3545;background-color:#dc3545!important;color:#fff!important;margin-right:30px}.single-product-page.onMobile ._section[data-v-21f7bcfa]{border-bottom:1px solid #d8d3d3}.single-product-page.onMobile .product-covers .carousel[data-v-21f7bcfa]{box-shadow:none}.single-product-page.onMobile ._details[data-v-21f7bcfa]{font-size:20px}", "", {"version":3,"sources":["/home/circleci/repo/static/styles/singleProduct.scss"],"names":[],"mappings":"AACA,+BACE,eAAiB,CAClB,AACD,gCACE,gBAAkB,CACnB,AACD,wBACE,SAAW,CACZ,AACD,yBACE,QAAU,CACX,AACD,kCACE,6BAAgC,AAChC,gBAAkB,AAClB,cAAgB,CACjB,AACD,4BACE,WAAY,AACZ,WAAY,AACZ,+BAAqC,CACtC,AACD,8BACE,oBAAsB,AACtB,0BAA6B,CAC9B,AACD,oCACI,YAAc,CACjB,AACD,0CACI,eAAgB,AAChB,6BAAiC,AACjC,gBAAiB,AACjB,eAAgB,AAChB,WAAa,AACb,UAAa,CAChB,AACD,iDACM,SAAW,CAChB,AACD,+CACI,eAAgB,AAChB,eAAiB,CACpB,AACD,yDACE,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,8BAA+B,AACnC,4BAAiC,CAClC,AACD,0EACI,4BAAiC,CACpC,AACD,4FACI,sCAAyC,CAC5C,AACD,qGACI,WAAY,AACZ,uBAA4B,CAC/B,AACD,kGACI,kBAAmB,AACnB,aAAc,AACd,YAAa,AACb,wBAA4B,AAC5B,sBAAuB,AACvB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,eAAiB,CACpB,AACD,wGACM,WAAY,AACZ,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,MAAO,AACP,OAAQ,AACR,qBAAuB,CAC5B,AACD,kHACI,6BAA8B,AAC9B,0CAAmD,CACtD,AACD,iFACI,SAAW,CACd,AACD,6FACM,aAAc,AACd,WAAY,AACZ,wBAA4B,AAC5B,uBAAyB,CAC9B,AACD,mDACE,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,yDACI,SAAW,CACd,AACD,mEACE,QAAU,CACX,AACD,6EACE,mBAAoB,AACpB,cAAgB,CACjB,AACD,mFACI,UAAa,CAChB,AACD,2EACE,gBAAiB,AACjB,eAAgB,AAChB,WAAa,AACb,4BAAiC,CAClC,AACD,wDACE,gBAAkB,AAClB,eAAgB,AAChB,qBAA0B,AAC1B,4BAAiC,CAClC,AACD,oDACE,eAAgB,AAChB,gBAAkB,AAClB,WAAa,AACb,cAAe,AACf,4BAAiC,CAClC,AACD,wDACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,kBAAoB,CACzB,AACD,oEACI,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,wBAA4B,AAC5B,mBAAoB,AACpB,iBAAmB,CACtB,AACD,mEACI,eAAgB,AAChB,gBAAiB,AACjB,wBAA0B,CAC7B,AACD,qDACE,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,kBAAsB,CACvB,AACD,uDACE,eAAiB,CAClB,AACD,8DACI,gBAAkB,AAClB,cAAgB,CACnB,AACD,wDACE,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,eAAkB,CACnB,AACD,2DACE,cAAe,AACf,WAAe,AACf,gBAAiB,AACjB,aAAc,AACd,eAAiB,CAClB,AACD,wEACI,yBAA2B,CAC9B,AACD,uDACE,gBAAiB,AACjB,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,sBAAuB,AACnB,6BAA+B,CACpC,AACD,kEACI,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACnB,mBAAoB,AACxB,qBAAsB,AAClB,sBAAwB,CAC/B,AACD,mEACI,oBAAqB,AACrB,gBAAiB,AACjB,YAAa,AACb,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,+BAAmC,AACnC,gBAAkB,AAClB,iBAAmB,CACtB,AACD,0EACM,yBAA0B,AAC1B,mCAAqC,AACrC,oBAAuB,CAC5B,AACD,6EACM,sBAA0B,AAC1B,oBAAqB,AACrB,iCAAmC,AACnC,oBAAuB,CAC5B,AACD,mFACQ,2BAA6B,AAC7B,mCAAqC,AACrC,qBAAuB,AACvB,iBAAmB,CAC1B,AACD,yDACE,+BAAiC,CAClC,AACD,yEACE,eAAiB,CAClB,AACD,yDACE,cAAgB,CACjB","file":"singleProduct.scss","sourcesContent":["\n.page-content[data-v-21f7bcfa] {\n  margin-top: 45px;\n}\n.filter-invert[data-v-21f7bcfa] {\n  filter: invert(1);\n}\n.w-100[data-v-21f7bcfa] {\n  width: 100;\n}\n.gap-20[data-v-21f7bcfa] {\n  gap: 20px;\n}\n.general-heading[data-v-21f7bcfa] {\n  font-family: 'Inter',sans-serif;\n  font-weight: bold;\n  font-size: 20px;\n}\n.divider-x[data-v-21f7bcfa] {\n  width: 100%;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n.info-dialog[data-v-21f7bcfa] {\n  width: 70% !important;\n  max-width: 1100px !important;\n}\n.info-dialog .card[data-v-21f7bcfa] {\n    padding: 30px;\n}\n.info-dialog .modal-head[data-v-21f7bcfa] {\n    font-size: 16px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 600;\n    cursor: pointer;\n    color: black;\n    opacity: 0.5;\n}\n.info-dialog .modal-head.active[data-v-21f7bcfa] {\n      opacity: 1;\n}\n.info-dialog .modal-body-text[data-v-21f7bcfa] {\n    font-size: 16px;\n    font-weight: 400;\n}\n.single-product-page .product-container[data-v-21f7bcfa] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  font-family: 'Inter', sans-serif;\n}\n.single-product-page .product-container .product-section[data-v-21f7bcfa] {\n    font-family: 'Inter', sans-serif;\n}\n.single-product-page .product-container .input-group--select__autocomplete[data-v-21f7bcfa] {\n    background-color: transparent !important;\n}\n.single-product-page .product-container .product-side-thumbnails .product-thumbnail[data-v-21f7bcfa] {\n    width: 100%;\n    background-position: center;\n}\n.single-product-page .product-container .product-side-thumbnails .product-covers[data-v-21f7bcfa] {\n    position: relative;\n    height: 130px;\n    width: 130px;\n    background-position: center;\n    background-size: cover;\n    margin-bottom: 25px;\n    cursor: pointer;\n    box-shadow: none;\n    border-radius: 6px;\n    overflow: hidden;\n}\n.single-product-page .product-container .product-side-thumbnails .product-covers[data-v-21f7bcfa]::after {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      background-color: none;\n}\n.single-product-page .product-container .product-side-thumbnails .selected .product-covers[data-v-21f7bcfa]::after {\n    background-color: transparent;\n    box-shadow: 0 0 4px 0px rgba(154, 154, 163, 0.562);\n}\n.single-product-page .product-container .product-cover-selected[data-v-21f7bcfa] {\n    width: 75%;\n}\n.single-product-page .product-container .product-cover-selected .__selected[data-v-21f7bcfa] {\n      height: 600px;\n      width: 100%;\n      background-position: center;\n      background-size: contain;\n}\n.single-product-page .flex-center[data-v-21f7bcfa] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.single-product-page .flex-center .w-80[data-v-21f7bcfa] {\n    width: 80%;\n}\n.single-product-page .info-link-container .gap-15[data-v-21f7bcfa] {\n  gap: 10px;\n}\n.single-product-page .info-link-container .info-modal-links[data-v-21f7bcfa] {\n  margin-bottom: 15px;\n  cursor: pointer;\n}\n.single-product-page .info-link-container .info-modal-links[data-v-21f7bcfa]:hover {\n    opacity: 0.8;\n}\n.single-product-page .info-link-container .info-link-text[data-v-21f7bcfa] {\n  font-weight: 500;\n  font-size: 16px;\n  color: black;\n  font-family: 'Inter', sans-serif;\n}\n.single-product-page .product-category[data-v-21f7bcfa] {\n  font-weight: bold;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.5);\n  font-family: 'Inter', sans-serif;\n}\n.single-product-page .product-name[data-v-21f7bcfa] {\n  font-size: 34px;\n  font-weight: bold;\n  color: black;\n  line-height: 1;\n  font-family: 'Inter', sans-serif;\n}\n.single-product-page .product-merchant[data-v-21f7bcfa] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.single-product-page .product-merchant .tag__image[data-v-21f7bcfa] {\n    height: 50px;\n    width: 50px;\n    background-size: cover;\n    background-position: center;\n    border-radius: 100%;\n    margin-right: 10px;\n}\n.single-product-page .product-merchant .tag__name[data-v-21f7bcfa] {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n.single-product-page .product-price[data-v-21f7bcfa] {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -1%;\n  margin: 10px 0 30px 0;\n}\n.single-product-page .product-options[data-v-21f7bcfa] {\n  margin-top: 30px;\n}\n.single-product-page .product-options__title[data-v-21f7bcfa] {\n    font-weight: bold;\n    font-size: 16px;\n}\n.single-product-page .product-addTobag[data-v-21f7bcfa] {\n  margin-top: 15px;\n  height: 50px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.single-product-page .product-description[data-v-21f7bcfa] {\n  line-height: 2;\n  color: #000000;\n  margin-top: 30px;\n  height: 100px;\n  overflow-y: auto;\n}\n.single-product-page .product-description[data-v-21f7bcfa]:first-letter {\n    text-transform: capitalize;\n}\n.single-product-page .product-actions[data-v-21f7bcfa] {\n  margin-top: 20px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.single-product-page .product-actions .__actions[data-v-21f7bcfa] {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n}\n.single-product-page .product-actions .follow-btx[data-v-21f7bcfa] {\n    text-transform: none;\n    box-shadow: none;\n    height: 31px;\n    font-size: 14px;\n    letter-spacing: 0;\n    min-width: 100px;\n    font-family: 'DM Sans', sans-serif;\n    font-weight: bold;\n    border-radius: 4px;\n}\n.single-product-page .product-actions .follow-btx.follow[data-v-21f7bcfa] {\n      border: 1px solid #076AFF;\n      background-color: #076AFF !important;\n      color: #fff !important;\n}\n.single-product-page .product-actions .follow-btx.following[data-v-21f7bcfa] {\n      border: 1px solid #000000;\n      border-radius: 100px;\n      background-color: #0000 !important;\n      color: #000 !important;\n}\n.single-product-page .product-actions .follow-btx.following[data-v-21f7bcfa]:hover {\n        border: 0.75px solid #dc3545;\n        background-color: #dc3545 !important;\n        color: #fff !important;\n        margin-right: 30px;\n}\n.single-product-page.onMobile ._section[data-v-21f7bcfa] {\n  border-bottom: 1px solid #d8d3d3;\n}\n.single-product-page.onMobile .product-covers .carousel[data-v-21f7bcfa] {\n  box-shadow: none;\n}\n.single-product-page.onMobile ._details[data-v-21f7bcfa] {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1891)("72bf5543", content, true, {});

/***/ }),

/***/ 2149:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page single-product-page mx-5"
  }, [(_vm.isPageReady) ? _c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n              < Back\n            ")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', {
    staticClass: "ml-0 pl-0",
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "margin-top-header": ""
    }
  }, [_c('v-flex', {
    staticClass: "wrapFlex product-covers",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "product-container"
  }, [(!_vm.onMobile) ? _c('div', {
    staticClass: "product-side-thumbnails"
  }, _vm._l((_vm.covers), function(img, i) {
    return _c('div', {
      key: i,
      staticClass: "product-thumbnail",
      class: img === _vm.selectedCover ? 'selected' : '',
      on: {
        "click": function($event) {
          _vm.changeFeaturedImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "product-covers",
      style: ({
        'background-image': ("url(" + img + ")"),
      })
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-cover-selected"
  }, [_c('div', {
    staticClass: "__selected",
    style: ({
      'background-image': ("url(" + _vm.selectedCover + ")"),
    })
  })])])]), _vm._v(" "), (_vm.product) ? _c('v-flex', {
    staticClass: "product-details",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "product-section pl-3"
  }, [_c('div', {
    staticClass: "product-category"
  }, [_vm._v(_vm._s(_vm.productCategoryName))]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.product.price * 100)))]), _vm._v(" "), _c('div', {
    staticClass: "product-options"
  }, [_c('v-select', {
    staticClass: "large",
    attrs: {
      "items": _vm.options,
      "item-text": "name",
      "placeholder": "Select option",
      "item-value": "id",
      "single-line": "",
      "bottom": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  })], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "product-addTobag",
    attrs: {
      "round": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.product.stock > 0 ? _vm.addToCart() : ''
      }
    }
  }, [(_vm.product.stock > -1) ? _c('span', [_vm._v("Add to cart")]) : _c('span', [_vm._v("Out of Stock")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider-x  mt-5 mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "product-merchant"
  }, [_c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "user": _vm.product.merchant
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider-x  mt-3 mb-4"
  }), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "product-actions"
  }, [_c('user-follow-btn', {
    staticClass: "follow-btx",
    attrs: {
      "user": _vm.user,
      "theme": "blue",
      "type": "product",
      "borderRadius": "",
      "btnBlock": ""
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.addToCollections()
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3 filter-invert",
    attrs: {
      "src": __webpack_require__(57),
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Add to wishlist")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('span', {
    staticClass: "__actions pl-0",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "cursor-pointer mt-3",
    attrs: {
      "src": "/static/images/ic_share.svg",
      "width": "20"
    },
    on: {
      "click": function($event) {
        _vm.share_dialog = true
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Share")])])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider-x my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex w-100"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_vm._v("\n                " + _vm._s(_vm.product.description) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "info-link-container"
  }, [_c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 1)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1978),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Size & Fit\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 2)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1978),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Shipping Policy\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 3)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1978),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Return Policy\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-modal-links dflex align-center gap-15",
    on: {
      "click": function($event) {
        (_vm.info_dialog = true) && (_vm.info_active_tab = 4)
      }
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1978),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-link-text"
  }, [_vm._v("\n                      Privacy Policy\n                    ")])])])])]), _vm._v("''\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "divider-x my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "general-heading mb-4"
  }, [_vm._v("More from this seller")]), _vm._v(" "), _c('div', {}, [_c('v-layout', {
    staticClass: "covers-content"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "card-container",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('product-card', {
      attrs: {
        "dataObject": product,
        "showFullOverlay": ""
      }
    })], 1)
  }))], 1)])], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('div', {
    staticClass: "flex-center py-5"
  }, [_c('comments', {
    staticClass: "w-80",
    attrs: {
      "item": _vm.product,
      "comments": _vm.comments,
      "commentTableType": _vm.commentTableType
    },
    on: {
      "reRenderComments": _vm.reRenderComments
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "info-dialog"
    },
    model: {
      value: (_vm.info_dialog),
      callback: function($$v) {
        _vm.info_dialog = $$v
      },
      expression: "info_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "general-heading w-100 mb-2"
  }, [_vm._v("\n              Info\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center gap-20"
  }, [_c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 1) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 1)
      }
    }
  }, [_vm._v("Size & Fit")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 2) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 2)
      }
    }
  }, [_vm._v("Shipping policy")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 3) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 3)
      }
    }
  }, [_vm._v("Return policy")]), _vm._v(" "), _c('div', {
    staticClass: "modal-head",
    class: (_vm.info_active_tab == 4) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.info_active_tab = 4)
      }
    }
  }, [_vm._v("Privacy policy")])])]), _vm._v(" "), _c('v-card-text', [_c('div', [((_vm.info_active_tab == 1)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Size and fit\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 2)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Shipping policy\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 3)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Return policy\n              ")]) : _vm._e(), _vm._v(" "), ((_vm.info_active_tab == 4)) ? _c('div', {
    staticClass: "modal-body-text"
  }, [_vm._v("\n                Privacy policy\n              ")]) : _vm._e()])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "margin-top": "3%"
    },
    attrs: {
      "content-class": ["finish-modal upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseProductModal),
      callback: function($$v) {
        _vm.showReleaseProductModal = $$v
      },
      expression: "showReleaseProductModal"
    }
  }, [(_vm.showReleaseProductModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseProduct,
      "type": "product",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2107)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2062),
  /* template */
  __webpack_require__(2149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21f7bcfa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/49.0c32262c95411bb307c6.js